export default __webpack_public_path__ + "static/media/news58.552adb49.jpg";